module.exports = __webpack_public_path__ + "img/logo_splashscreen.5b0b3266.png";